<template>
  <RenderlessComponent>
    <slot
      :filters="provision.items"
      :options="provision.options"
      :dynamic-options="provision.dynamicOptions"
      :models="provision.models"
      :selected="provision.selected"
      :selected-list="provision.selectedList"
      :set="set"
      :reset="reset"
      :resetOne="resetOne"
    />
  </RenderlessComponent>
</template>

<script>
  import RenderlessComponent from 'src/components/RenderlessComponent/RenderlessComponent.vue';

  export default {
    name: 'FiltersProvider',
    components: { RenderlessComponent },
    props: {
      name: {
        type: String,
        default: 'filters',
      },
      filters: {
        type: Object,
        default: () => ({}),
      },
      options: {
        type: Object,
        default: () => ({}),
      },
      dynamicOptions: {
        type: Object,
        default: () => ({}),
      },
      models: {
        type: Object,
        default: () => ({}),
      },
      groups: {
        type: Array,
        default: () => [],
      }
    },
    provide() {
      return { [this.name]: this.provision };
    },
    data() {
      const ctx = this;
      const { filters, options, dynamicOptions, models, reset, resetOne, set } = ctx;
      return {
        provision: {
          items: { ...filters },
          options,
          dynamicOptions: { ...dynamicOptions },
          models,
          get selected() {
            const { items, models } = ctx.provision;
            const res = {};

            for (const key in items) {
              const value = items[key];
              const model = models[key];
              
              if (!value) continue;
              if (model) {
                if ('default' in model && model.default === value) continue;
                if ('isSelected' in model && !model.isSelected({ items, value })) continue;
              }

              res[key] = value;
            }

            return res;
          },
          get selectedList() {
            const { items: filters, aggregateOptions, models, selected } = ctx.provision;
            const res = [];
            
            const getTitle = (key, value) => {
              let title;
              const optionsKey = models[key] && models[key].optionsKey;
              const actualKey = optionsKey || key;

              if (actualKey in aggregateOptions) {
                const option = aggregateOptions[actualKey].find(modelItem => modelItem.value === value);

                if (option) {
                  if (optionsKey) {
                    return option.title;
                  }

                  title = option.title;
                }
              }
              if (key in models) {
                const model = models[key]
                return typeof model.title === 'function' ?
                  model.title({ options: aggregateOptions, filters, value, title }) :
                  model.title;
              }
              return title;
            };

            for (const key in selected) {
              const value = selected[key];

              if (Array.isArray(value)) {
                
                for (const filterValue of value) {
                  res.push({
                    id: `${key}-${filterValue}`,
                    title: getTitle(key, filterValue),
                    key,
                    value: filterValue,
                  });
                }
                
              } else {
                res.push({
                  id: key,
                  title: getTitle(key, value),
                  key,
                  value,
                });
              }
            }

            return res;
          },
          get aggregateOptions() {
            const { options, dynamicOptions } = ctx.provision;
            return {...options, ...dynamicOptions};
          },

          // заполняем соц сети только если все выбранные специализации относятся к одной родительской специализации
          // и если у родительской специализации заполнены соц сети
          get socialLinks() {
            const { aggregateOptions, selectedList } = ctx.provision;
            const key = 's';
            const getSpecsParentId = (value) => {
              const option = aggregateOptions[key].find(modelItem => modelItem.value === value);
              if (option && option.parent_id) {
                return option.parent_id;
              }
              return 0;
            };

            const specsSelectedFilters = selectedList.filter(item => item.key === key);
            const parentIds = specsSelectedFilters.map(item => getSpecsParentId(item.value));
            
            if (new Set(parentIds).size === 1) {
              const parentGroup = ctx.groups.find(item => item.id === parentIds[0]);
              if (parentGroup?.social_links && Object.keys(parentGroup.social_links).length !== 0) {
                return {
                  title: parentGroup.title,
                  links: parentGroup.social_links,
                }
              }
            }
            return null;
          },
          set,
          reset,
          resetOne,
        }
      };
    },
    methods: {
      reset() {
        const { items } = this.provision;

        Object.keys(items).forEach(key => {
          const value = items[key];
          if (Array.isArray(value)) {
            items[key] = [];
          } else {
            this.resetOne({ key, value });
          }
        });
      },
      // eslint-disable-next-line complexity
      resetOne(filterItem) {
        const { models, provision } = this;
        const { items } = provision;
        const { key, value } = filterItem;

        if (key in models && 'default' in models[key]) {
          items[key] = models[key].default;
        } else if (Array.isArray(items[key])) {
          items[key] = items[key].filter(item => item !== value);
        } else {
          items[key] = null;
        }
        if (models[key] && models[key].partOf) {
          models[key].partOf.forEach(partOfKey => {
            this.resetOne({ key: partOfKey, value });
          });
        }
      },
      set({ filters, dynamicOptions }) {
        this.reset();
        this.provision.items = { ...this.provision.items, ...filters };
        this.provision.dynamicOptions = { ...dynamicOptions };
      }
    },
  };
</script>